<template>
  <div class="dbs_pr-container">
    <transition name="modal">
      <modal v-if="visible" :canClose="!isProcessing" isClose="true" @modal-close="modalClose">
        <template v-if="isReviewAdded" @isProcessingChanged="isProcessingChanged">
          <h2 class="t-head t-head--primary u-text-center">Dziękujemy za Twoją opinię!</h2>
          <h3 class="t-head--subtitle">Pomagasz innym dokonywać lepszych wyborów.</h3>
          <ul class="c-actions-list u-justify-content-end">
            <li class="c-actions-list__item">
              <a @click="modalClose" class="c-btn c-btn--secondly c-btn--theme-6 u-text-uppercase f_right l-opinions__btn">
                <span class="c-btn__wrap">
                  <span class="c-btn__label">Zamknij</span>
                </span>
              </a>
            </li>
          </ul>
        </template>
        <template v-else>
          <AddProductReviewForm
            :initialRating="initialRating"
            :product="product"
            :average-rating="averageRating"
            :reviews-count="reviewsCount"
            @review-added="reviewAdded"
          />
        </template>
      </modal>
    </transition>
  </div>
</template>
<script>
import {EventBus, GlobalEvents} from '@/shared'
import Modal from '@/components/Modal.vue'
import AddProductReviewForm from './AddProductReviewForm.vue'
import {getProductRating} from '@/api/productReviews'

export default {
  components: {
    Modal,
    AddProductReviewForm
  },

  data () {
    return {
      visible: false,
      isReviewAdded: false,
      isProcessing: false,

      product: {},
      averageRating: 0,
      reviewsCount: 0,
      initialRating: null
    }
  },

  mounted () {
    EventBus.$on(GlobalEvents.reviews_showAddReviewForm, ({product, initialRating}) => {
      this.averageRating = this.reviewsCount = 0

      if (initialRating) {
        this.initialRating = initialRating
      }

      const self = this
      getProductRating(product.id)
        .then(rating => {
          self.averageRating = rating.rating
          self.reviewsCount = rating.count
        })

      this.product = product
      this.visible = true
    })
    EventBus.$on(GlobalEvents.reviews_processingChanged, ({isProcessing}) => {
      this.isProcessing = isProcessing
    })
  },

  methods: {
    modalClose () {
      this.visible = false
      this.isReviewAdded = false
    },

    reviewAdded () {
      this.isReviewAdded = true

      EventBus.$emit(GlobalEvents.myAccountReviews_reloadReviews)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AddProductReviewForm/AddProductReviewModal.vue